import React, {Component} from 'react'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import {Popup, Grids} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import {filterDiscuss, isNewWeiXinMachine} from '../../utils'
import { WKCommentDialog } from '../../components/wk'


import ToCreateLiveroom from '../../images/to_create_liveroom2.png'
import '../../styles/classroom/ClassroomControlBar.css'
import { isChannelCPS } from '../../utils/cps'

class ClassroomDiscussBar extends Component {
    constructor() {
        super();
        this.onShowDiscussPanel = this.onShowDiscussPanel.bind(this);
        this.onSetPlaybackRate = this.onSetPlaybackRate.bind(this);
        this.onOpenUserMenu = this.onOpenUserMenu.bind(this);
        this.onTextInputChange = this.onTextInputChange.bind(this);
        this.onTextInputBlur = this.onTextInputBlur.bind(this);
        this.onTextInputFocus = this.onTextInputFocus.bind(this);
        this.onTextSubmit = this.onTextSubmit.bind(this);
        this.onEnterLiveroom = this.onEnterLiveroom.bind(this);
        this.renderPlaybackRate = this.renderPlaybackRate.bind(this);
    }


    state = {
        showPlusCommands: false,
        plusCommands: [],
        inputMode: 'text',
        isShowCommentDialog: false,
    };

    hide() {
        this.setState({
            showPlusCommands: false
        })
    }

    componentWillMount() {
        const commands = [{
            icon: <i className="iconfont icon-zhaopian" aria-hidden="true"></i>,
            label: '图片',
            onClick: null
        }];

        this.setState({
            plusCommands: commands
        });
    }

    componentWillUnmount() {
        this.fixInputPosition && clearInterval(this.fixInputPosition);
    }

    onShowDiscussPanel() {
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_DISCUSS_PANEL',
            payload: 'discuss_list'
        })
    }

    onOpenUserMenu() {
        this.props.dispatch({
            type: 'CLASSROOM_SET_MENU_DISPLAY',
            payload: true
        })
    }

    onTextSubmit(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ isShowCommentDialog: false })
        const {discussList, showedNoListenDialog} = this.props

        const content = discussList.draft

        let text = () => {
            return <p><i className="iconfont icon-cuowu wk-toast-error"/><span>不能发空白消息</span></p>
        };
        if (content.trim().length === 0) {
            this.context.page.showToast(text(), '', true, 2000)
            return;
        }

        if (content.length < 1) {
            return
        }

        if (filterDiscuss(content) && !showedNoListenDialog) {
            this.onTextInputBlur();
            this.refs.textInput.value = ''
            this.props.dispatch({
                type: 'DISCUSS_UPDATE_DRAFT',
                payload: ''
            })
            this.props.dispatch({type: 'CLASSROOM_SHOW_NOLISTEN_DIALOG', payload: 'listen'});
            this.props.dispatch({type: 'CLASSROOM_SHOW_SHOWED_NOLISTEN_DIALOG'});
            return;
        }

        const {lecture, account} = this.props
        const m = {
            type: 'discuss_text',
            content: content,
            account: account,
            timestamp: Date.now() * 0.001
        }

        axios.post('/api/classroom/' + lecture.id + '/discuss/send', qs.stringify(m)).then((response) => {
            if (response.data.code === 0) {
                this.refs.textInput.value = ''
                this.props.dispatch({
                    type: 'DISCUSS_UPDATE_DRAFT',
                    payload: ''
                })
                this.props.dispatch({
                    type: 'DISCUSS_SEND',
                    payload: m
                })
                this.props.dispatch({
                    type: 'ROBOT_SET_DISCUSS',
                    payload: m
                })
            } else {
                alert(response.data.msg)
            }
        }).catch((error) => {
            alert(error)
        })
    }

    onTextInputFocus() {
        this.props.dispatch({
            type: 'DISCUSS_SHOW_WRITING'
        })

        this.props.dispatch({
            type: 'CLASSROOM_VIRTUAL_FOCUS'
        })
        if (!isNewWeiXinMachine()) {
            this.fixInputPosition && clearInterval(this.fixInputPosition);
            this.fixInputPosition = setInterval(() => {
                document.body.scrollTop = document.body.scrollHeight;
            }, 1000);
        } else {
            this.setState({ isShowCommentDialog: true }, () => {
                this.$textarea.focus()
            })
        }
    }

    onTextInputBlur() {
        this.props.dispatch({
            type: 'DISCUSS_HIDE_WRITING'
        })

        this.props.dispatch({
            type: 'CLASSROOM_VIRTUAL_BLUR'
        })
        clearInterval(this.fixInputPosition);
    }

    onTextInputChange(e) {
        this.props.dispatch({
            type: 'DISCUSS_UPDATE_DRAFT',
            payload: e.target.value
        })
    }

    onEnterLiveroom() {
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'create_liveroom_fr_classroom'
        });
        window.location = '/liveroom/create/guide?fr=room'
    }

    onSetPlaybackRate() {
        this.context.classroomPage.onSetPlaybackRate()
    }

    renderPlaybackRate(playbackRate) {
        switch(playbackRate) {
            case '0.7':
                return <i className="iconfont icon-icon-test1 menu-font"/>
            case '1.0':
                return <i className="iconfont icon-icon-test menu-font"/>
            case '1.5':
                return <i className="iconfont icon-icon-test4 menu-font"/>
            case '2.0':
                return <i className="iconfont icon-icon-test2 menu-font"/>
            case '2.5':
                return <i className="iconfont icon-icon-test3 menu-font"/>
            case '3.0':
                return <i className="iconfont icon-icon-test5 menu-font"/>
            default:
                return <i className="iconfont icon-icon-test menu-font"/>
        }
    }

    render() {
        const {options, discussList, playbackRate} = this.props
        const showInput = discussList.draft || discussList.writing
        const inputAttrs = options.can_discuss ? {} : {disabled: 'disabled'}

        return (
            <form action="" method="post" onSubmit={this.onTextSubmit}>
                <Popup
                    show={this.state.showPlusCommands}
                    onRequestClose={e => this.setState({showPlusCommands: false})}
                >
                    <Grids data={this.state.plusCommands}/>
                </Popup>

                <div className={`classroom-control-bar weui-flex ` + (showInput ? "writing" : "") }>
                    {!this.props.account.has_liveroom &&
                    <component className="flex_1 weui-btn_default menu-button-liveroom"
                    onClick={this.onEnterLiveroom}>
                        <img src={ToCreateLiveroom} alt="" style={{width: '34px', height: '34px'}}/>
                    </component>
                    }
                    <component className="flex_4 text-input">
                        <input  type="text"
                                placeholder={options.can_discuss ? '发表评论' : '课堂暂时不允许评论'}
                                ref="textInput" {...inputAttrs}
                                value={isNewWeiXinMachine() ? '' : discussList.draft}
                                onFocus={this.onTextInputFocus}
                                onBlur={this.onTextInputBlur}
                                onChange={this.onTextInputChange}
                                readOnly={isNewWeiXinMachine()}
                                onClick={this.onTextInputFocus}
                        />
                    </component>
                    <input type="submit" className="flex_1 weui-btn weui-btn_primary text-send"
                           value="发送"/>
                    <component className="flex_1 weui-btn_default menu-button hide"
                               onClick={e => this.setState({showPlusCommands: true})}>
                        <i className="iconfont icon-xinbanketangye-gengduo menu-font"></i>
                    </component>
                    <component className="flex_1 weui-btn_default menu-button"
                               onClick={this.onSetPlaybackRate}>
                        {this.renderPlaybackRate(playbackRate)}
                    </component>
                    {!isChannelCPS() && <component className="flex_1 weui-btn_default menu-button"
                        onClick={this.onShowDiscussPanel}>
                        <i className="iconfont icon-xinbanketangye-pinglun menu-font"></i>
                    </component>}
                    {!isChannelCPS() && <component className="flex_1 weui-btn_default menu-button"
                        onClick={this.onOpenUserMenu}>
                        <i className="iconfont icon-xinbanketangye-caidan menu-font"></i>
                    </component>}
                    <WKCommentDialog type="ios" title='发表评论' buttons={[
                        { label: '取消', type: 'default', onClick: e => this.setState({ isShowCommentDialog: false }) },
                        { label: '提交', onClick: e => this.onTextSubmit(e) }
                    ]} show={this.state.isShowCommentDialog}>
                        <textarea
                            rows="4"
                            onChange={this.onTextInputChange}
                            value={discussList.draft}
                            ref={r => this.$textarea = r}
                        >
                        </textarea>
                    </WKCommentDialog>
                </div>
            </form>
        )
    }
}


ClassroomDiscussBar.contextTypes = {
    page: React.PropTypes.object,
    classroomPage: React.PropTypes.object
};


export default connect((state) => ({
    account: state.account,
    options: state.classroom.options,
    lecture: state.classroom.lecture,
    discussList: state.discussList,
    showedNoListenDialog: state.classroom.showedNoListenDialog,
    playbackRate: state.audioPlayer.playbackRate
}))(ClassroomDiscussBar);




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomDiscussBar.js